import http from './httpClient';

// API методы для админ панели
export const adminApiService = {
  // Получение статистики дашборда
  getDashboardStats: async () => {
    const response = await http.get('/api/accounts/dashboard-stats/');
    return response.data;
  },

  // Получение списка пользователей
  getUsers: async (params = {}) => {
    const response = await http.get('/api/accounts/admin/users/', { params });
    // Если ответ - массив, оборачиваем в объект с results для совместимости
    if (Array.isArray(response.data)) {
      return { results: response.data, count: response.data.length };
    }
    return response.data;
  },

  // Получение детальной информации о пользователе
  getUserDetails: async (userId) => {
    const response = await http.get(`/api/accounts/admin/users/${userId}/`);
    return response.data;
  },

  // Обновление пользователя
  updateUser: async (userId, data) => {
    console.log('API: Обновление пользователя', userId, data);
    const response = await http.patch(`/api/accounts/admin/users/${userId}/`, data);
    console.log('API: Ответ сервера', response.data);
    return response.data;
  },

  // Создание нового пользователя
  createUser: async (data) => {
    const response = await http.post('/api/accounts/admin/users/', data);
    return response.data;
  },

  // Удаление пользователя
  deleteUser: async (userId) => {
    const response = await http.delete(`/api/accounts/admin/users/${userId}/`);
    return response.data;
  },

  // Блокировка/разблокировка пользователя
  toggleUserStatus: async (userId, isActive) => {
    const response = await http.post(`/api/accounts/admin/users/${userId}/toggle-status/`);
    return response.data;
  },

  // Сброс пароля пользователя
  resetUserPassword: async (userId, newPassword) => {
    const response = await http.post(`/api/accounts/admin/users/${userId}/reset-password/`, {
      new_password: newPassword
    });
    return response.data;
  },

  // Назначение/снятие прав администратора
  toggleUserStaff: async (userId, isStaff) => {
    const response = await http.post(`/api/accounts/admin/users/${userId}/toggle-staff/`);
    return response.data;
  },

  // Назначение/снятие прав суперпользователя
  toggleUserSuperuser: async (userId, isSuperuser) => {
    const response = await http.post(`/api/accounts/admin/users/${userId}/toggle-superuser/`);
    return response.data;
  },

  // Назначение/снятие прав бухгалтера
  toggleAccountant: async (userId, isAccountant) => {
    const response = await http.post(`/api/accounts/admin/users/${userId}/toggle-accountant/`);
    return response.data;
  },

  // Назначение/снятие прав кассира
  toggleCashier: async (userId) => {
    const response = await http.post(`/api/accounts/admin/users/${userId}/toggle-cashier/`);
    return response.data;
  },

  // Получение профиля кассира
  getCashierProfile: async (userId) => {
    const response = await http.get(`/api/cashier/profile/${userId}/`);
    return response.data.cashier_profile;
  },

  // Создание профиля кассира
  createCashierProfile: async (userId, data) => {
    const response = await http.post(`/api/accounts/admin/users/${userId}/create-cashier-profile/`, data);
    return response.data;
  },

  // Обновление профиля кассира
  updateCashierProfile: async (userId, data) => {
    const response = await http.patch(`/api/accounts/admin/users/${userId}/update-cashier-profile/`, data);
    return response.data;
  },

  // Получение заведений для кассиров
  getEstablishments: async () => {
    console.log('🔍 adminApi: Запрос к /api/establishments/list/');
    const response = await http.get('/api/establishments/list/');
    console.log('✅ adminApi: Получен response:', response);
    console.log('📦 adminApi: response.data:', response.data);
    console.log('📊 adminApi: Тип response.data:', typeof response.data);
    console.log('📊 adminApi: Array.isArray(response.data):', Array.isArray(response.data));
    
    // Если response.data - массив, возвращаем его напрямую
    if (Array.isArray(response.data)) {
      console.log('✅ adminApi: Возвращаем массив напрямую');
      return response.data;
    }
    
    // Если это объект с полем results
    if (response.data && response.data.results) {
      console.log('✅ adminApi: Возвращаем response.data.results');
      return response.data.results;
    }
    
    // В крайнем случае возвращаем как есть
    console.log('⚠️ adminApi: Возвращаем response.data как есть');
    return response.data;
  },

  // Получение филиалов заведения
  getEstablishmentLocations: async (establishmentId) => {
    const response = await http.get(`/api/establishments/${establishmentId}/locations/`);
    return response.data;
  },

  // Получение групп пользователей
  getUserGroups: async () => {
    const response = await http.get('/api/accounts/auth/groups/');
    return response.data;
  },

  // Получение разрешений
  getUserPermissions: async () => {
    const response = await http.get('/api/accounts/auth/permissions/');
    return response.data;
  },

  // Обновление групп пользователя
  updateUserGroups: async (userId, groupIds) => {
    const response = await http.patch(`/api/accounts/admin/users/${userId}/`, {
      groups: groupIds
    });
    return response.data;
  },

  // Обновление разрешений пользователя
  updateUserPermissions: async (userId, permissionIds) => {
    const response = await http.patch(`/api/accounts/admin/users/${userId}/`, {
      user_permissions: permissionIds
    });
    return response.data;
  },

  // Получение активности пользователя
  getUserActivity: async (userId, params = {}) => {
    const response = await http.get(`/api/accounts/admin/users/${userId}/activities/`, { params });
    return response.data;
  },

  // Экспорт пользователей
  exportUsers: async (format = 'csv', params = {}) => {
    const response = await http.get('/api/accounts/admin/users/export/', {
      params: { format, ...params },
      responseType: 'blob'
    });
    return response.data;
  },

  // Получение заказов
  getOrders: async (params = {}) => {
    const response = await http.get('/api/orders/', { params });
    return response.data;
  },

  // Получение деталей заказа
  getOrderDetails: async (orderId) => {
    const response = await http.get(`/api/orders/${orderId}/`);
    return response.data;
  },

  // Обновление статуса заказа
  updateOrderStatus: async (orderId, status) => {
    const response = await http.patch(`/api/orders/${orderId}/`, { status });
    return response.data;
  },

  // Получение меню
  getMenu: async (params = {}) => {
    const response = await http.get('/api/menu/dishes/', { params });
    return response.data;
  },

  // Получение категорий меню
  getMenuCategories: async () => {
    const response = await http.get('/api/menu/categories/');
    return response.data;
  },

  // Создание/обновление блюда
  createDish: async (data) => {
    const response = await http.post('/api/menu/dishes/', data);
    return response.data;
  },

  updateDish: async (dishId, data) => {
    const response = await http.patch(`/api/menu/dishes/${dishId}/`, data);
    return response.data;
  },

  // Удаление блюда
  deleteDish: async (dishId) => {
    const response = await http.delete(`/api/menu/dishes/${dishId}/`);
    return response.data;
  },

  // Получение активности пользователей
  getUserActivities: async (params = {}) => {
    const response = await http.get('/api/accounts/activities/', { params });
    return response.data;
  },

  // Получение статистики активности
  getActivityStats: async () => {
    const response = await http.get('/api/accounts/activities/activity_stats/');
    return response.data;
  },

  // Получение категорий пользователей
  getUserCategories: async () => {
    const response = await http.get('/api/accounts/categories/');
    return response.data;
  },

  // Обновление бонусных баллов
  updateBonusPoints: async (userId, data) => {
    const response = await http.post('/api/accounts/update-bonus-points/', {
      user_id: userId,
      ...data
    });
    return response.data;
  },

  // Получение настроек заведения
  getEstablishmentSettings: async () => {
    const response = await http.get('/api/establishments/');
    return response.data;
  },

  // Обновление настроек заведения
  updateEstablishmentSettings: async (establishmentId, data) => {
    const response = await http.patch(`/api/establishments/${establishmentId}/`, data);
    return response.data;
  },

  // Получение аналитики продаж
  getSalesAnalytics: async (params = {}) => {
    const response = await http.get('/api/analytics/sales/', { params });
    return response.data;
  },

  // Получение популярных блюд
  getPopularDishes: async (params = {}) => {
    const response = await http.get('/api/analytics/popular-dishes/', { params });
    return response.data;
  },
};

export default http;